import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import guards from '@/router/guards'
import resolveGuards from '@/router/resolveGuards'
import { rawRoutes } from './routes'
import { normalizeRoutesMeta } from '@/router/utils/normalize-routes'
import { DEFAULT_META } from './constants'

export const routes: RouteRecordRaw[] = normalizeRoutesMeta(rawRoutes, DEFAULT_META)

const router = createRouter({
  // 使用 BASE_URL，兼容子路径部署（如 /app/）
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  // 统一滚动行为——优先还原浏览器记录，其次回到顶部
  scrollBehavior(_to, _from, saved) {
    if (saved) return saved
    return { left: 0, top: 0 }
  },
})

// 注册路由守卫
// 说明：认证状态恢复已在 main.ts 中的 bootstrap() 函数完成
// 守卫中通过 auth.whenReady() 确保状态就绪，无需额外的 appReadyGuard
guards.before.forEach(router.beforeEach)
guards.after.forEach(router.afterEach)

// 在导航被确认前做“可取消”的解析型守卫（如数据预取、权限判定等）
resolveGuards.forEach((guard) => {
  router.beforeResolve(guard)
})

// 处理懒加载 chunk 失效（发版后旧包残留/网络抖动），自动重试当前路由
router.onError((err) => {
  const msg = (err && (err as Error).message) || ''
  if (/Loading chunk \d+ failed|ChunkLoadError|dynamically imported module/i.test(msg)) {
    const { fullPath } = router.currentRoute.value
    router.replace(fullPath).catch(() => window.location.assign(fullPath))
  }
})

export default router
